import { render, staticRenderFns } from "./ProjectPage.vue?vue&type=template&id=ff21d0e4&scoped=true"
import script from "./ProjectPage.vue?vue&type=script&lang=js"
export * from "./ProjectPage.vue?vue&type=script&lang=js"
import style0 from "./ProjectPage.vue?vue&type=style&index=0&id=ff21d0e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff21d0e4",
  null
  
)

export default component.exports